import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowUpRight } from "lucide-react";
import { BOOKING_URL, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL } from "@/data";
import { COLLAPSE } from "@/components/Reveal";
import { NavItem } from "@/components/NavItem";
import { track } from "@/hooks/useAnalytics";

export const MobileMenu = ({ open, onNavigate, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div {...COLLAPSE} className="overflow-hidden border-b border-stone/70 bg-cream/97 backdrop-blur-xl lg:hidden">
        <div className="flex flex-col gap-1 px-6 py-6">
          {NAV_LINKS.map((l) => (
            <span key={l.label} onClick={l.to ? onClose : undefined}>
              <NavItem
                link={l}
                onSection={onNavigate}
                testid={`nav-mobile-link-${l.id || l.to.slice(1)}`}
                className="block border-b border-stone/60 py-3 font-serif text-2xl text-ink transition-colors hover:text-forest"
              />
            </span>
          ))}
          <div className="mt-5 flex flex-col gap-3">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-book-button"
              onClick={() => track("book_click", { location: "nav-mobile-book-button" })}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-forest px-6 py-3.5 font-sans font-medium text-cream"
            >
              Book Online <ArrowUpRight className="h-4 w-4" />
            </a>
            <a href={PHONE_TEL} className="inline-flex items-center justify-center gap-2 rounded-md border border-ink/25 px-6 py-3.5 font-sans text-ink">
              <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
